/* global mapboxgl */
import Vue from 'vue';
import axios from 'axios';

new Vue({
  el: '#employers-app',
  data: {
    selected: '',
    csv: '/feeds/employers.csv',
    addresses: {
      type: 'FeatureCollection',
      features: [],
    },
  },
  methods: {

    // Popup
    openPopup: function (feature) {

      var coordinates = feature.geometry.coordinates.slice();
      var description = feature.properties.description;

      if (!this.popUp) this.popUp = new mapboxgl.Popup({ offset: 5 });
      this.popUp
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(this.map);
    },

    // Industry selector
    // When input is changed, bring in the new value
    onSelectIndustry(event) {
      const csvTarget = event.target.options[event.target.options.selectedIndex].dataset;
      this.csv = csvTarget.link;
    },

    setupMap: function () {

      mapboxgl.accessToken = 'pk.eyJ1IjoiZW5jb3JlbXVsdGltZWRpYSIsImEiOiJjazBlOXhmbGowZnNpM2JtbWs5MmlpNnBkIn0.iP8U5cKjK8filrbWu44p1A';

      var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v8',
        center: [-81.693316, 41.498620],
        zoom: 10,
      });

      this.map = map;

      // On first load, pull date form the store
      map.on('load', () => {


        map.addSource('employers', {
          type: 'geojson',
          data: this.filteredAddresses || {},
        });

        map.addLayer({
          'id': 'employers',
          'source': 'employers',
          'type': 'circle',
          'paint': {
            'circle-radius': 6,
            'circle-color': ['get', 'color'],
          },
        });

        map.on('click', 'employers', (e) => {
          var coordinates = e.features[0].geometry.coordinates.slice();
          var description = e.features[0].properties.description;

          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }

          if (!this.popUp) this.popUp = new mapboxgl.Popup({ offset: 5 });
          this.popUp
            .setLngLat(coordinates)
            .setHTML(description)
            .addTo(map);
        });

        map.on('mouseenter', 'employers', () => {
          map.getCanvas().style.cursor = 'pointer';
        });

        map.on('mouseleave', 'employers', () => {
          map.getCanvas().style.cursor = '';
        });
      });
    },
  },

  watch: {
    filteredAddresses(newValues) {
      if (this.map && newValues) {
        const sourceData = this.map.getSource('employers');
        if (sourceData) sourceData.setData(newValues);
      }
    },
  },

  computed: {
    filteredAddresses() {
      if (!this.selected || this.selected == '*') return this.addresses;

      // Creates a new array to dump the filtered items in
      let results = [];
      this.addresses.features.map(item => {
        if (item.industry == this.selected) {
          results.push(item);
        }
      });

      return {
        type: 'FeatureCollection',
        features: results || [],
      };
    },
  },

  created() {
    this.map = null;// here we define map as non-reactive
    this.popUp = null;
  },

  mounted: function () {
    // Grab data from the endpoint and set addresses, then setup the map
    axios
      .get('/api/employers')
      .then(response => {
        this.addresses = response.data;
        this.setupMap();
      });

    // this.$nextTick(() => {
    //   this.setupMap();
    // });
  },

  updated() {
    // clear popup here
    if (this.popUp) this.popUp.remove();
  }
});
